import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import { AuthProvider } from './admin/context/AuthContext'
import ProtectedRoute from './admin/components/ProtectedRoute'
import AdminLayout from './admin/components/AdminLayout'
import {
  Login,
  Dashboard,
  Invoices,
  InvoiceForm,
  Expenses,
  ExpenseForm,
  Clients,
  ClientForm,
  Vendors,
  VendorForm,
  Projects,
  ProjectForm,
  Categories,
  Recurring,
  RecurringForm,
  Settings,
  BankStatements,
  BankStatementDetail,
  BankStatementTransactions,
  TimeTrack,
  Timesheets,
  TimeTrackReports,
  UsersList,
  UserDetail,
  AcceptInvitation,
} from './admin/pages'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />

        {/* Public invitation acceptance */}
        <Route
          path="/invite/accept"
          element={
            <AcceptInvitation />
          }
        />

        {/* Admin routes */}
        <Route
          path="/admin/login"
          element={
            <AuthProvider>
              <Login />
            </AuthProvider>
          }
        />

        <Route
          path="/admin"
          element={
            <AuthProvider>
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            </AuthProvider>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="invoices/new" element={<InvoiceForm />} />
          <Route path="invoices/:id" element={<InvoiceForm />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="expenses/new" element={<ExpenseForm />} />
          <Route path="expenses/:id" element={<ExpenseForm />} />
          <Route path="recurring" element={<Recurring />} />
          <Route path="recurring/new" element={<RecurringForm />} />
          <Route path="recurring/:id" element={<RecurringForm />} />
          <Route path="clients" element={<Clients />} />
          <Route path="clients/new" element={<ClientForm />} />
          <Route path="clients/:id" element={<ClientForm />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="vendors/new" element={<VendorForm />} />
          <Route path="vendors/:id" element={<VendorForm />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/new" element={<ProjectForm />} />
          <Route path="projects/:id" element={<ProjectForm />} />
          <Route path="categories" element={<Categories />} />
          <Route path="bank-statements" element={<BankStatements />} />
          <Route path="bank-statements/transactions" element={<BankStatementTransactions />} />
          <Route path="bank-statements/:id" element={<BankStatementDetail />} />
          <Route path="timetrack" element={<TimeTrack />} />
          <Route path="timetrack/reports" element={<TimeTrackReports />} />
          <Route path="timesheets" element={<Timesheets />} />
          <Route path="users" element={<UsersList />} />
          <Route path="users/:id" element={<UserDetail />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
